import { FiEdit2, FiTrash2 } from "react-icons/fi";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

const ActionButtons = ({ onEdit, onDelete }) => (
  <div className="flex items-center justify-center space-x-2">
    <Tooltip title="Edit" arrow>
      <IconButton
        size="small"
        type="button"
        onClick={onEdit}
        className="text-blue-600 hover:text-blue-800 hover:bg-blue-50"
        sx={{
          '&:hover': {
            backgroundColor: 'rgba(59, 130, 246, 0.1)'
          }
        }}
      >
        <FiEdit2 size={16} />
      </IconButton>
    </Tooltip>
    <Tooltip title="Delete" arrow>
      <IconButton
        size="small"
        type="button"
        onClick={onDelete}
        className="text-red-600 hover:text-red-800 hover:bg-red-50"
        sx={{
          '&:hover': {
            backgroundColor: 'rgba(239, 68, 68, 0.1)'
          }
        }}
      >
        <FiTrash2 size={16} />
      </IconButton>
    </Tooltip>
  </div>
);

export default ActionButtons;


